import * as React from "react"
import { ConfigProvider } from "antd"
import enUS from "antd/es/locale/en_US"
import esEs from "antd/es/locale/es_ES"
import ptBR from "antd/es/locale/pt_BR"
import { Languages, i18next } from "locale"

export const AntdLangContext: React.FC = ({ children }) => {
	const code = i18next.language

	const lang =
		code === Languages.SPANISH
			? esEs
			: code === Languages.PORTUGUESE
			? ptBR
			: enUS

	return <ConfigProvider locale={lang}>{children}</ConfigProvider>
}
